import {
    ProductCalculationWithAssociations,
    productCalculationWithAssociationsDecoder
} from '../../Entities/ProductCalculationWithAssociations'
import {MessageWithTranslation} from '../../Entities/MessageWithTranslation.entity.evolve'
import {
    ProductShippingService,
    productShippingServiceDecoder
} from '../../Entities/ProductShippingService'
import {array, Decoder, field, object} from 'json-bouncer'
import {Editable} from '../../Data/Editable'
import {PriceDefinition} from '../../Entities/PriceDefinition'
import {Customer, customerDecoder} from '../../Entities/Customer'
import {HttpError} from '../../Data/Http'

export interface ProductCalculationDetailsState {
    readonly content: ProductCalculationDetailsContent

    readonly priceDefinitionList: EditablePriceDefinitionRow[]

    readonly editable: Editable<null>

    readonly typeSearch: string
    readonly typeSuggestions: MessageWithTranslation[]
    readonly selectedTypeId: number

    readonly formatSearch: string
    readonly formatSuggestions: MessageWithTranslation[]
    readonly selectedFormatId: number

    readonly coverageSearch: string
    readonly coverageSuggestions: MessageWithTranslation[]
    readonly selectedCoverageId: number

    readonly printSearch: string
    readonly printSuggestions: MessageWithTranslation[]
    readonly selectedPrintId: number

    readonly paperSearch: string
    readonly paperSuggestions: MessageWithTranslation[]
    readonly selectedPaperId: number

    readonly processingSearch: string
    readonly processingSuggestions: MessageWithTranslation[]
    readonly selectedProcessingId: number

    readonly weightInput: string
    readonly weightValidation: 'InvalidInt' | 'Mandatory' | null

    readonly selectedShippingService: number

    readonly submissionAttempted: boolean

    readonly selectedCustomers: number[]
    readonly selectedCustomersValidation: 'EmptyArray' | null

    readonly createNewMessageModal: string | null
    createNewMessageModalInput: string
    createNewMessageModalInputValidation: 'Mandatory' | null
    createNewMessageModalTranslation: string
    createNewMessageModalTranslationValidation: 'Mandatory' | null
    newMessageSubmissionAttempted: boolean
    readonly error: HttpError | null
}

export interface PriceDefinitionInput {
    readonly quantity: string
    readonly price: string
}

export interface PriceDefinitionValidation {
    readonly quantity: 'Mandatory' | 'InvalidInt' | 'NotUniqueInArray' | null
    readonly price: 'Mandatory' | 'InvalidFixedPointNumber' | null
}

export interface EditablePriceDefinitionRow {
    readonly origin: PriceDefinition
    readonly input: PriceDefinitionInput
    readonly validation: PriceDefinitionValidation
    readonly deleted: boolean
}

export interface ProductCalculationDetailsContent {
    readonly productCalculationWithAssociations: ProductCalculationWithAssociations
    readonly availableShippingServices: ProductShippingService[]
    readonly availableCustomers: Customer[]
}

export function productCalculationDetailsContentDecoder(): Decoder<ProductCalculationDetailsContent> {
    return object({
        productCalculationWithAssociations: field('productCalculation', productCalculationWithAssociationsDecoder()),
        availableShippingServices: field('availableShippingServices', array(productShippingServiceDecoder())),
        availableCustomers: field('availableCustomers', array(customerDecoder()))
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/ProductCalculationDetails/ProductCalculationDetailsState.ts